export interface RiskFlowEconEventDefinition {
  key: string;
  title: string;
  patterns: RegExp[];
  lowerIsBullish?: boolean;
}

export const RISKFLOW_ECON_EVENT_DEFINITIONS: RiskFlowEconEventDefinition[] = [
  {
    key: "COREPCE",
    title: "Core PCE Price Index",
    patterns: [/core\s+pce/i, /core\s+personal\s+consumption/i],
    lowerIsBullish: true,
  },
  {
    key: "PCE",
    title: "PCE Price Index",
    patterns: [/\bpce\b/i, /personal\s+consumption/i],
    lowerIsBullish: true,
  },
  {
    key: "CORECPI",
    title: "Core Consumer Price Index",
    patterns: [/core\s+cpi/i, /core\s+consumer\s+price/i],
    lowerIsBullish: true,
  },
  {
    key: "CPI",
    title: "Consumer Price Index",
    patterns: [/\bcpi\b/i, /consumer\s+price/i],
    lowerIsBullish: true,
  },
  {
    key: "COREPPI",
    title: "Core Producer Price Index",
    patterns: [/core\s+ppi/i, /core\s+producer\s+price/i],
    lowerIsBullish: true,
  },
  {
    key: "PPI",
    title: "Producer Price Index",
    patterns: [/\bppi\b/i, /producer\s+price/i],
    lowerIsBullish: true,
  },
  {
    key: "JOLTS",
    title: "JOLTS Job Openings",
    patterns: [/\bjolts\b/i, /job\s+openings/i],
  },
  {
    key: "NFP",
    title: "Non-Farm Payrolls",
    patterns: [/non.?farm/i, /payroll/i],
  },
  {
    key: "INIT",
    title: "Initial Jobless Claims",
    patterns: [/initial\s+jobless/i, /jobless\s+claims/i],
    lowerIsBullish: true,
  },
  {
    key: "UNEMP",
    title: "Unemployment Rate",
    patterns: [/unemployment\s+rate/i],
    lowerIsBullish: true,
  },
  {
    key: "CONF",
    title: "Consumer Confidence",
    patterns: [/consumer\s+confidence/i, /conference\s+board/i, /\bcb\b/i],
  },
  {
    key: "UMICH",
    title: "Michigan Consumer Sentiment",
    patterns: [/michigan/i, /consumer\s+sentiment/i],
  },
  {
    key: "PMI",
    title: "Purchasing Managers' Index",
    patterns: [/\bpmi\b/i, /purchasing\s+managers/i, /\bism\b/i],
  },
  {
    key: "GDP",
    title: "Gross Domestic Product",
    patterns: [/\bgdp\b/i, /gross\s+domestic/i],
  },
  {
    key: "RETA",
    title: "Retail Sales",
    patterns: [/retail\s+sales/i],
  },
  {
    key: "DURABLE",
    title: "Durable Goods",
    patterns: [/durable\s+goods/i],
  },
  {
    key: "HOUSING",
    title: "Housing Starts",
    patterns: [/housing\s+starts/i, /building\s+permits/i],
  },
];
